import { lazy, Suspense, useContext } from 'react'
import ColonyAvatar from '@/components/ColonyAvatar'
import { WalletAddressContext, WalletReadyContext } from '@/lib/walletContext'

const ColonyAvatarEditorInnerLazy = lazy(() => import('@/components/ColonyAvatarEditorInner'))

function ColonyAvatarEditor() {
  const ready = useContext(WalletReadyContext)
  const wallet = useContext(WalletAddressContext)

  if (!ready) {
    return <ColonyAvatar wallet={wallet} size="lg" />
  }

  return (
    <Suspense fallback={<ColonyAvatar wallet={wallet} size="lg" />}>
      <ColonyAvatarEditorInnerLazy />
    </Suspense>
  )
}

export default ColonyAvatarEditor
